export type INumberFormatProps = {
  value: number
  maximumFractionDigits?: number
  minimumFractionDigits?: number
  currency?: 'USD' | 'CAD' | string
}

export const numberFormat = ({
  value,
  maximumFractionDigits = undefined,
  minimumFractionDigits = undefined,
  currency,
}: INumberFormatProps) =>
  new Intl.NumberFormat('en-US', {
    style: currency ? 'currency' : undefined,
    currency,
    minimumFractionDigits,
    maximumFractionDigits,
  }).format(value)

export const numberFormatInt = ({ value, currency }: INumberFormatProps) =>
  numberFormat({ value, currency, minimumFractionDigits: 0, maximumFractionDigits: 0 })

export const numberFormatIntUsd = ({ value }: INumberFormatProps) =>
  numberFormatInt({ value, currency: 'USD' })

// use as numberCompactFormatter.format(val)
export const numberCompactFormatter = new Intl.NumberFormat('en', {
  notation: 'compact',
})

export const clampNumber = (
  value: number,
  min = Number.MIN_SAFE_INTEGER,
  max = Number.MAX_SAFE_INTEGER
) => Math.max(min, Math.min(value, max))
